let drawerController = null;

const getElements = () => {
  const drawer = document.querySelector('[data-sidebar-drawer]');
  const toggle = document.querySelector('.js-improved-drawer-toggle');
  return { drawer, toggle };
};

const buildController = (drawer, toggle) => {
  let drawerIsOpen = false;

  const openDrawer = () => {
    drawer.classList.add('is-open');
    document.body.classList.add('sidebar-drawer-open');
    toggle.setAttribute('aria-expanded', 'true');
    drawerIsOpen = true;
  };

  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    document.body.classList.remove('sidebar-drawer-open');
    toggle.setAttribute('aria-expanded', 'false');
    drawerIsOpen = false;
  };

  return {
    open: openDrawer,
    close: closeDrawer,
    isOpen: () => drawerIsOpen
  };
};

const attachEventHandlers = (drawer, toggle, controller) => {
  if (!drawer || !toggle) {
    return;
  }

  const bindCloseHandler = (element) => {
    if (!element) {
      return;
    }
    element.addEventListener('click', controller.close);
  };

  const closeButtons = drawer.querySelectorAll('[data-drawer-close]');
  closeButtons.forEach((btn) => bindCloseHandler(btn));

  const menuLinks = drawer.querySelectorAll('.sidebar-menu a');
  menuLinks.forEach((link) => bindCloseHandler(link));

  toggle.setAttribute('aria-expanded', 'false');
  toggle.addEventListener('click', (event) => {
    event.preventDefault();
    if (!document.body.classList.contains('top-page-improved')) {
      return;
    }
    if (controller.isOpen()) {
      controller.close();
    } else {
      controller.open();
    }
  });

};

export const initializeSidebarDrawer = () => {
  const { drawer, toggle } = getElements();
  if (!drawer || !toggle) {
    drawerController = null;
    return;
  }

  if (drawer.dataset.drawerInitialized === 'true') {
    return;
  }
  drawer.dataset.drawerInitialized = 'true';

  drawerController = buildController(drawer, toggle);
  attachEventHandlers(drawer, toggle, drawerController);
};

export const getSidebarDrawerController = () => drawerController;

export const registerSidebarDrawerBootstrap = () => {
  const init = () => initializeSidebarDrawer();
  document.addEventListener('turbolinks:load', init);
  document.addEventListener('DOMContentLoaded', init);
};

const handleDocumentKeyup = (event) => {
  if (event.key !== 'Escape') {
    return;
  }
  const controller = getSidebarDrawerController();
  if (controller && controller.isOpen()) {
    controller.close();
  }
};

document.addEventListener('keyup', handleDocumentKeyup);
